const products = {
  ERP: "https://erp.youstad.com",
  LEDGER: "https://ledger.youstad.com",
  DOCKET: "https://docket.youstad.com",
  BITE: "https://bite.youstad.com",
};

export default products;
